'use strict';

var App = require('app');
var AppState = require('app_state');
var Consts = require('consts');
var Decorator = require('utils/decoration');
var i18n = require('utils/i18n');
var Lock = require('components/common/behaviors/lock');
var Misc = require('utils/misc');
var Notification = require('utils/notification');
var svgUtils = require('utils/svg');
var TimeProgramModel = require('components/devices/views/controller/time_program_model');
var utils = require('components/devices/views/controller/handling_view_utils');

var HandlingView = Backbone.Marionette.ItemView.extend({
    template: require('components/devices/templates/controller/device_handling'),

    events: {
        'click button.js-temperature': 'showTemperature',
        'click button#js-betriebsart': 'showOperatingModeDialogView',
        'click button.js-edit-timeprogram': 'showTimeProgramDialogView',
    },

    behaviors: {
        lock: {
            behaviorClass: Lock,
            buttons: [
                '#js-0',
                '#js-1',
                '#js-2',
                '#js-betriebsart',
                '#js-timeprogram-0',
                '#js-timeprogram-1',
                '#js-timeprogram-2',
            ],

            getDeviceID: function (view) {
                return view.model.get('deviceID');
            },
        },
    },

    initialize: function (options) {
        utils.initializeConstants();

        this.controller = options.controller;
        this.computedMode = utils.simpleDisplayMode(
            this.model.attributes.mode_chosen,
            this.model.attributes.mode_active
        );
        this.device = options.device;
        this.parentCategory = AppState.getDeviceInfo(this.device.get('wired_to')).category;
        this.inconsistent = { dataPoints: [], timePrgs: [] };
        if (options.inconsistent) {
            this.inconsistent.dataPoints = options.inconsistent.data_points || [];
            this.inconsistent.timePrgs = options.inconsistent.time_programs || [];
        }
        this.initTimeprogramModel();
        this.smartTemp = options.smartTempInfo;
    },

    serializeData: function () {
        var data = Marionette.ItemView.prototype.serializeData.apply(this, arguments);
        data.warnings = [];
        data.chosenModeSetting = utils.modeConfigs[this.model.attributes.mode_chosen];
        data.activeModeSetting = utils.modeConfigs[this.model.attributes.mode_active];
        data.computedModeSetting = utils.modeConfigs[this.computedMode];
        data.modeConfigs = utils.modeConfigs;
        data.activationDate =
            this.model.attributes.auto_timer != 0 &&
            (this.model.attributes.is_holiday || this.model.attributes.mode_chosen != 'auto')
                ? moment().add(this.model.attributes.auto_timer, 'minutes').format('DD.MM.YYYY HH:mm')
                : undefined;
        data.timePrograms = this.timePrograms;
        data.extendedView = AppState.user.attributes.is_expert;
        data.readOnly = this.readOnly || !this.model.attributes.is_configurable || this.model.attributes.is_holiday;

        data.inconsistentRegisters = this.isInconsistent();
        var decreasedUsability = !Misc.isFirmwareSufficient(this.device.get('firmware'), '2.28');
        var is4PointCharacteristic = this.model.get('is_4_point_characteristic');
        var showNoConfigHint = !this.readOnly && !this.model.attributes.is_configurable;
        if (decreasedUsability) {
            data.decreasedUsability = true;
            data.warnings.push({
                title: i18n.TR('Eingeschränkte Bedienung'),
                info: i18n.TR(
                    'Die Firmware Ihres Reglers ist kleiner als 2.28, daher ist die Bedienung nur eingeschränkt nutzbar.'
                ),
            });
        } else if (is4PointCharacteristic) {
            data.warnings.push({
                title: i18n.TR('4-Punkte-Kennlinie aktiviert'),
                info: i18n.TR('Bei aktivierter 4-Punkte-Kennlinie kann die Temperatur nicht eingestellt werden.'),
            });
        }
        if (showNoConfigHint) {
            data.warnings.push({
                title: i18n.TR('Keine Einstellungen möglich.'),
                info: i18n.TR(
                    'Der Heizkreis kann momentan nicht fernbedient werden, da er direkt am Gerät eingestellt wurde.'
                ),
            });
        }
        if (this.smartTemp) {
            data.warnings = data.warnings.concat(
                this.smartTemp.getWarnings(
                    i18n.TR('Die Einstellungen können nicht verändert werden, solange Smart Temp aktiv ist.')
                )
            );
        }

        data.showBtnOpMode = !this.readOnly && this.model.attributes.is_configurable && !decreasedUsability;

        if (!is4PointCharacteristic) {
            for (var i = 0; i < 3; i++) {
                data.temperatures[i].canEdit = !this.readOnly && this.model.attributes.is_configurable;
            }
            data.temperatures[0].canEdit = data.temperatures[0].canEdit && !decreasedUsability;
        }
        return data;
    },

    // draw the timeprogram on render
    onRender: function () {
        this.initTimeprogramModel();

        // check if there is an svg-element, to which the drawing can be attached
        // (on the first call of "render", there isn't)
        if (document.getElementsByClassName('svg-container').length !== 0) {
            for (var i = 0; i < this.timePrograms.length; i++) {
                if (!this.timePrograms[i].inconsistent) {
                    this.updateTimelines(this.timePrograms[i]);
                }
            }
        }

        Misc.equalizeHeight($('.js-same-height'));
    },

    onShow: function () {
        this.onRender();
    },

    // updates all necessary data and redraws all changeable content of this view.
    // is used by other views which can change the data of this view.
    saveModel: function (newAttributes, successMessage, errorMessage) {
        var self = this;
        this.model.save(
            newAttributes, // attributes to set on the model
            {
                wait: true, // don't change the model, if the request fails
                success: function (model) {
                    App.hideModal();
                    self.computedMode = utils.simpleDisplayMode(
                        self.model.attributes.mode_chosen,
                        self.model.attributes.mode_active
                    );
                    Notification.show('success', i18n.TR('Erfolg'), successMessage);
                    self.refresh();
                },
                error: function () {
                    Notification.show('error', i18n.TR('Fehler'), errorMessage);
                    Decorator.enableElement('.modal-dialog');
                },
            }
        );
    },

    setPermission: function (permissions) {
        var requiredPermission = {
            10: Consts.Permissions.HandlingCircuit1,
            20: Consts.Permissions.HandlingCircuit2,
            30: Consts.Permissions.HandlingCircuit3,
            90: Consts.Permissions.HandlingWater,
            110: Consts.Permissions.HandlingCircuit11,
            120: Consts.Permissions.HandlingCircuit12,
            130: Consts.Permissions.HandlingCircuit13,
        };
        this.readOnly = permissions.get(requiredPermission[this.options.circuitNr]) || this.device.isWritingDisabled();
        if (this.smartTemp && (this.smartTemp.isActive() || this.smartTemp.isDryRun())) {
            this.readOnly = true;
        }
    },

    initTimeprogramModel: function () {
        this.timePrograms = [];
        for (var i = 0; i < this.model.attributes.time_programs.length; i++) {
            var tmp = this.model.attributes.time_programs[i];
            var inconsistent = _.contains(this.inconsistent.timePrgs, 'MBR_' + tmp.addr);

            TimeProgramModel.initialize(tmp.name, this.model.getTimeDataBitArray(i), i, undefined, inconsistent);
            this.timePrograms.push(
                $.extend(true, {}, TimeProgramModel, { timelines: TimeProgramModel.getTimelinesToDraw() })
            );
        }
    },

    refresh: function () {
        var url = Backbone.history.fragment;
        Backbone.history.loadUrl(url);
    },

    updateTimelines: function (timeModel) {
        var timelines = timeModel.getTimelinesToDraw();
        for (var i = 0; i < timelines.length; i++) {
            if (document.getElementById('svg-' + timelines[i].ID) != null) {
                this.forgeTimeLine(timelines[i].data, timelines[i].ID);
            }
        }
    },

    isInconsistent: function (showNote) {
        if (
            this.inconsistent.dataPoints.length > 0 &&
            (this.inconsistent.dataPoints.length > 1 || this.inconsistent.dataPoints[0] != 'MBR_145')
        ) {
            if (showNote) {
                Notification.show(
                    'warning',
                    i18n.TR('Warnung'),
                    i18n.TR('Vorangegangener Schreibbefehl wird verarbeitet.')
                );
                this.refresh();
            }
            return true;
        }
        return false;
    },

    showTemperature: function (e) {
        return this.isInconsistent(true) || this.controller.showTemperatureDialogView(e, this);
    },

    showOperatingModeDialogView: function (e) {
        return this.isInconsistent(true) || this.options.controller.showOperatingModeDialogView(e, this);
    },

    showTimeProgramDialogView: function (e) {
        var timeProgramNumber = parseInt($(e.currentTarget).attr('id').split('-')[2]);
        var timeProgram = this.timePrograms[timeProgramNumber];

        if (timeProgram.inconsistent === true) {
            Notification.show('warning', i18n.TR('Warnung'), i18n.TR('Zeitprogramm wird geschrieben.'));
            this.refresh();
        } else {
            this.options.controller.showTimeProgramDialogView(e, this, timeProgram);
        }
    },

    // draws a single timeline from a single timeprogram.
    // The drawing includes the intervals and their times
    forgeTimeLine: function (data, ID) {
        var timeData = data;
        var svgID = 'svg-' + ID;
        var svgContainer = document.getElementById(svgID);
        // # SVG soll 2+96+2 Einheiten breit sein, oder
        // # ein Vielfaches davon. Auf diese Weise entspricht eine
        // # x-Einheit in der SVG  einer viertel-Stunde im Zeitprogramm
        //
        // 0. SVG-Konstanten
        var textWidth = 75; // - Breite der Uhrzeit
        var LayerOne = 40; // - vertikale position der Uhrzeit
        var LayerSep = -5; // - vertikaler Abstand zwischen zwei layern
        var leftBorder = 8; // - offset der Zeit 0 zum SVG-Ursprung
        var rightBorder = 392; // - offset der Zeit 24 zum rechten Rand der SVG
        var textOffset = -2; // - vertikaler Abstand des Textes zur Linie über der er steht
        var vWidth = 4; // - Breite der Linienspitze, die auf das Intervall zeigt
        var vHeight = 45; // - Höhe der Linienspitze, die auf das Intervall zeigt
        var color = 'fill-custom'; // - Farbe der Schrift (Farbe und Schriftgröße)
        var fontSize = 12; // - Größe der Schrift

        // 1. Bestimme die Mittelpunkte aller Intervalle und initialisiere damit die Text-Mittelpunkte
        function getAnchors(intervalEndings) {
            var anchors = [];
            for (var i = (timeData[0] + 1) % 2; i < intervalEndings.length - 1; i = i + 2) {
                // Intervallendpunkte in x-Koordinaten der SVG umwandeln
                anchors[Math.floor(i / 2)] = (intervalEndings[i + 1] + intervalEndings[i]) / 2;
            }
            return anchors;
        }

        // returns the restricted shiftDistances for every given Point.
        function restrictShift(shiftDistance, pointToShift, textCenters) {
            // always positiv
            var maxAllowedShift;
            if (shiftDistance <= 0) {
                maxAllowedShift =
                    textDistance(textCenters[pointToShift - 1], textCenters[pointToShift]) ||
                    textDistance(leftBorder, textCenters[pointToShift]) + textWidth / 2;
            } else {
                maxAllowedShift =
                    textDistance(textCenters[pointToShift], textCenters[pointToShift + 1]) ||
                    textDistance(textCenters[pointToShift], rightBorder) + textWidth / 2;
            }

            if (Math.abs(shiftDistance) > maxAllowedShift) {
                return utils.sign(shiftDistance) * maxAllowedShift;
            }
            return shiftDistance;
        }

        // returns the allowed shift-distance for the given set of points.
        function averageAllowedShift(textAnchors, textPositions) {
            var averageShift = 0;
            var anchorCount = textAnchors.length;
            for (var i = 0; i < anchorCount; i++) {
                averageShift += textAnchors[i] - textPositions[i];
            }
            var shiftingPoint = averageShift > 0 ? anchorCount - 1 : 0;
            return restrictShift(averageShift / textAnchors.length, shiftingPoint, textPositions);
        }

        // 2. positions all textanchors in way they don't overlapp and are shifted in a balanced way
        function positionText(anchors) {
            var textPositions = anchors.slice();
            var textAnchors = anchors.slice();
            var taCount = textAnchors.length;

            // 2.1 Verschiebe alle Mittelpunkte nacheinander so nach rechts, dass sie links hinreichend viel Platz haben.
            //     (Ohne Beachtung der Ränder)
            var shifts = [];
            shifts[0] = -negativePart(textDistance(leftBorder, textPositions[0]) + textWidth / 2);
            if (taCount > 1) {
                shifts[1] = -negativePart(textDistance(textPositions[0] + shifts[0], textPositions[1]));
            }
            if (taCount > 2) {
                shifts[2] = -negativePart(textDistance(textPositions[1] + shifts[1], textPositions[2]));
            }

            // Addiere das Verschiebe-Array auf das Mittelpunkt array und setzte es dann auf Null zurück.
            for (var i = 0; i < taCount; i++) {
                textPositions[i] += shifts[i];
                shifts[i] = 0;
            }

            // Wiederhole den Vorgang in die andere Richtung, falls beim ersten Schritt etwas über den Rand geschoben worden ist.
            var end = shifts.length - 1;
            shifts[end] = negativePart(textDistance(textPositions[end], rightBorder) + textWidth / 2);
            if (end - 1 >= 0) {
                shifts[end - 1] = negativePart(textDistance(textPositions[end - 1], textPositions[end] + shifts[end]));
            }
            if (end - 2 >= 0) {
                shifts[0] = negativePart(
                    textDistance(textPositions[end - 2], textPositions[end - 1]) + shifts[end - 1]
                );
            }

            // Addiere das Verschiebe-Array auf das Mittelpunkt array und setzte es dann auf Null zurück.
            for (var i = 0; i < taCount; i++) {
                textPositions[i] += shifts[i];
                shifts[i] = 0;
            }

            // 2.3 Optimierung der Plätze: Verschiebe alle verschobenen Punkte - wenn möglich - soweit nach links,
            //     dass die Mittlere Verschiebung 0 ist.
            switch (taCount) {
                case 1:
                    // anchors already optimized
                    return textPositions;
                case 2:
                    // anchors already optimized

                    if (textDistance(textPositions[0], textPositions[1]) > 0) {
                        return textPositions;
                    }
                    // calculate the shift
                    var averageShift = averageAllowedShift(textAnchors, textPositions);
                    textPositions[0] += averageShift;
                    textPositions[1] += averageShift;
                    return textPositions;
                case 3:
                    var anchorOneAndTwoTouching = textDistance(textPositions[0], textPositions[1]) === 0;
                    var anchorTwoAndThreeTouching = textDistance(textPositions[1], textPositions[2]) === 0;
                    if (anchorOneAndTwoTouching && anchorTwoAndThreeTouching) {
                        // try to equalize the average shift to zero. A negativ average shift means,
                        // the text was mostly shifted to the right.
                        var averageShift = averageAllowedShift(textAnchors, textPositions);
                        textPositions[0] += averageShift;
                        textPositions[1] += averageShift;
                        textPositions[2] += averageShift;
                        return textPositions;
                    }
                    if (anchorOneAndTwoTouching && !anchorTwoAndThreeTouching) {
                        var averageShift = averageAllowedShift(textAnchors.slice(0, 2), textPositions.slice(0, 2));
                        textPositions[0] += averageShift;
                        textAnchors[1] += averageShift;
                        return textPositions;
                    }
                    if (!anchorOneAndTwoTouching && anchorTwoAndThreeTouching) {
                        var averageShift = averageAllowedShift(textAnchors.slice(1), textPositions.slice(1));
                        textPositions[1] += averageShift;
                        textAnchors[2] += averageShift;
                        return textPositions;
                    }
                    // anchors optimized
                    return textPositions;
            }
        }

        // 3. Festlegen der Linien-Endpunkte für jede Uhrzeit
        function calculateLineExtremities(textAnchor, textPosition) {
            var start = textPosition - textWidth / 2;
            var end = textPosition + textWidth / 2;
            start = start > textAnchor ? textAnchor : start;
            end = end < textAnchor ? textAnchor : end;
            return { start: start, end: end };
        }

        // 4. Für jede Linie eine Ebene festlegen (wenn möglich alle auf der ersten Ebene).
        // Bestimme die Länge aller Linien. Die kürzesten bekommen die höchste Ebene, die längsten die niedrigste
        function setLayer(lineExtremities, textPositions, anchors) {
            // shiftDirection is greater zero if the textPositions where generaly shifted more to the right
            var shiftDirection = 0;
            var entryCount = anchors.length;
            for (var i = 0; i < entryCount; i++) {
                shiftDirection += textPositions[i] - anchors[i];
            }

            var layers = [];
            if (shiftDirection > 0) {
                layers[entryCount - 1] = LayerOne;
                for (var i = entryCount - 2; i >= 0; i--) {
                    if (
                        lineExtremities[i].end > anchors[i + 1] - vWidth &&
                        lineExtremities[i].start < anchors[i + 1] + vWidth
                    ) {
                        layers[i] = layers[i + 1] + LayerSep;
                    } else {
                        layers[i] = LayerOne;
                    }
                }
            } else {
                layers[0] = LayerOne;
                for (var i = 1; i < entryCount; i++) {
                    if (
                        anchors[i - 1] + vWidth > lineExtremities[i].start &&
                        anchors[i - 1] - vWidth < lineExtremities[i].end
                    ) {
                        layers[i] = layers[i - 1] + LayerSep;
                    } else {
                        layers[i] = LayerOne;
                    }
                }
            }
            return layers;
        }

        function negativePart(number) {
            return number > 0 ? 0 : number;
        }

        // returns the distance between two texts (e.g times, for example "13:45") corresponding to their anchors.
        // Can be negativ, if the texts would overlap. Has to be at least the textWidth do be greater than zero.
        function textDistance(firstPoint, secondPoint) {
            return secondPoint - firstPoint - textWidth;
        }

        // 6. Zeichenfunktionen
        // - drawInterval zeichnet das Intervall auf dem 24h-Zeitstrahl
        function drawInterval(svg, start, end) {
            var intLength = end - start;
            start = start + leftBorder;
            var path = 'M' + start + ' 50 l' + intLength + ' 0';
            svgUtils.drawPath(svg, path, { strokeWidth: '8' });
        }

        // 5. drawTimeLabel Zeichnet eine Linien samt Zeitspanne über ein gegebenes Intervall
        function drawTimeLabel(svg, start, end, layer, timespan, anchorPosition, timePosition) {
            anchorPosition += leftBorder;
            start += leftBorder;
            timePosition += leftBorder;

            // if the anchor lies outside of |<-start----end->|, move start/end to anchor-position
            start >= anchorPosition ? (start = anchorPosition - vWidth) : (start = start);
            end < anchorPosition ? (end = anchorPosition) : (end = end);
            var lineBeforeAnchor = anchorPosition - start - vWidth;
            var lineAfterAnchor = end - anchorPosition;
            var path =
                'M' +
                start +
                ' ' +
                layer + // Startpunkt
                ' l' +
                lineBeforeAnchor +
                ' 0 ' + // Mittelpunkt
                'l' +
                vWidth +
                ' ' +
                (vHeight - layer) +
                ' l' +
                vWidth +
                ' ' +
                (layer - vHeight) + // V (Anchor)
                ' l' +
                lineAfterAnchor +
                ' 0'; // Ende

            svgUtils.drawPath(svg, path);
            svgUtils.drawText(svg, ' ' + timespan + ' ', {
                x: timePosition,
                y: layer + textOffset,
                class: color,
                'font-size': fontSize,
            });
        }

        // ########################### --- Programmstart --- #########################
        // 5. Zeichnen der Linie von Start bis Ende mit einer Spitze auf den Intervallmittelpunkt und der Zeitspanne darüber

        var svgUnitsPerTimeUnit = 4;
        var convertedTimeData = utils.convertTimeData(timeData);

        var intervalEndings = convertedTimeData[0];
        var timeLabels = convertedTimeData[1];

        // convert the interval endints to svg-units.
        for (var i = 0; i < intervalEndings.length; i++) {
            intervalEndings[i] *= svgUnitsPerTimeUnit;
        }
        var anchors = getAnchors(intervalEndings);
        var textPositions = positionText(anchors);
        var lines = [];
        for (var i = 0; i < anchors.length; i++) {
            lines[i] = calculateLineExtremities(anchors[i], textPositions[i]);
        }
        var Layers = setLayer(lines, textPositions, anchors);

        // start drawing---------------------------------

        // is the first interval empty or full?
        // if the first entry in timeData is zero, the first interval is empty,
        // so we start with the second one and visa versa.
        for (var k = (timeData[0] + 1) % 2; k < intervalEndings.length - 1; k += 2) {
            drawInterval(svgContainer, intervalEndings[k], intervalEndings[k + 1]);
        }

        for (var k = 0; k < timeLabels.length; k++) {
            drawTimeLabel(
                svgContainer,
                lines[k].start,
                lines[k].end,
                Layers[k],
                timeLabels[k],
                anchors[k],
                textPositions[k] - textWidth / 2
            );
        }
    },
});

module.exports = HandlingView;
